function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M51.9 8.8c-2.4-2.4-6.3-2.4-8.7 0L11.7 40.2c-.1.1-.2.2-.2.3 0 0 0 .1-.1.1-.1.1-.1.2-.1.3v.1L7.1 54.6c-.2.7 0 1.4.4 1.8.4.4.9.6 1.3.6.2 0 .4 0 .6-.1L23 52.8c.1-.1.2-.1.3-.1 0 0 .1 0 .1-.1.1-.1.2-.1.3-.2L55.1 21c2.4-2.4 2.4-6.3 0-8.7l-3.2-3.5zM11.7 52.3L14 45l5.1 5.1-7.4 2.2zm40.9-34.1l-3.7 3.7-6.8-6.8 3.7-3.7c1-1 2.5-1 3.5 0l3.3 3.3c1 1 1 2.6 0 3.5z"
})));